<template>
  <div class="pricing-page container">
    <h1>Pricing</h1>
    <p>
      The past questions are organized in to different application for different
      course combinations
    </p>

    <div class="pricing">
      <div class="product animated fadeInUp">
        <h3>Mobile application</h3>
        <div class="details">
          <img src="/images/subscription/phone.png" alt="" />
          <p class="price">
            <span class="strikethrough">₦ 500.00</span> ₦350.00
          </p>
          <ul>
            <li>Upto 10 years including 2020</li>
            <li>All Questions are offline</li>
            <li>Take quiz and exama</li>
            <li>Answers to all questions</li>
            <li>
              Available on Android,
              <span style="text-decoration:line-through;" title="Coming soon">
                IOS
              </span>
            </li>
          </ul>
        </div>
        <a href="/register" class="button">Buy Now</a>
      </div>

      <div class="product animated fadeInUp">
        <h3>Desktop application</h3>
        <div class="details">
          <img src="/images/subscription/desktop.png" alt="" />
          <p class="price"><span class="strikethrough">₦ 700.00</span></p>
          <ul>
            <li>Upto 10 years including 2020</li>
            <li>All Questions are offline</li>
            <li>Take quiz and exama</li>
            <li>Answers to all questions</li>
            <li>Available only on Windows</li>
          </ul>
        </div>
        <div class="button disabled">
          Coming soon..
        </div>
      </div>

      <div class="product animated fadeInUp">
        <h3>Institution Access</h3>
        <div class="details">
          <img src="/images/subscription/desktop.png" alt="" />
          <p class="price"><span class="strikethrough">₦₦₦₦</span></p>
          <ul>
            <li>Upto 10 years including 2020</li>
            <li>All Questions are offline</li>
            <li>Take quiz and exama</li>
            <li>Answers to all questions</li>
            <li>Available only on Windows</li>
          </ul>
        </div>
        <div class="button disabled">
          Coming soon..
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pricing"
};
</script>
